<!-- results-table.component.html -->
<h1 mat-dialog-title>Cambiar nodo {{LOCAL_DATA.nombre}} de rama. </h1>
<div mat-dialog-content>

    <div class="content-card">

        <!-- CONTENT -->
        <div class="content p-24" fxFlex="100">
            <button mat-icon-button (click)="toRootItem()"><mat-icon>swap_horiz</mat-icon></button>
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <!-- This is the tree node template for leaf nodes -->
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding >
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
                <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
                <button mat-icon-button (click)="selectNode(node)" *ngIf="LOCAL_DATA.valor.id!=node.id"><mat-icon>swap_horiz</mat-icon></button>
                <!--
                <span *ngIf="node.usuarios!=null && node.usuarios.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
                <mat-chip-list aria-label="Usuarios" *ngIf="node.usuarios!=null && node.usuarios.length>0">
                  <mat-chip *ngFor="let usuario of node.usuarios">{{usuario.nombreCompleto}}</mat-chip>
                </mat-chip-list>-->
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding >
                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.name"
                        *ngIf="LOCAL_DATA.valor.id!=node.id">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
                <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
                <button mat-icon-button (click)="selectNode(node)"
                *ngIf="LOCAL_DATA.valor.id!=node.id"><mat-icon>swap_horiz</mat-icon></button>
                <!--
                <span *ngIf="node.usuarios!=null && node.usuarios.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
                <mat-chip-list aria-label="Usuarios" *ngIf="node.usuarios!=null && node.usuarios.length>0">
                  <mat-chip *ngFor="let usuario of node.usuarios">{{usuario.nombreCompleto}}</mat-chip>
                </mat-chip-list>-->
              </mat-tree-node>
            </mat-tree>

        </div>


    </div>


</div>
<div mat-dialog-actions>
  <!--<button mat-button (click)="doAction()" *ngIf="action != 'View'">Confirmar</button>-->
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
